import { SAVE_HLHL_CONTACT_ROLE } from "./types";

const saveHLHLContactRole = (hlhl_contact_role: string) => (dispatch: any) => {
  dispatch({
    type: SAVE_HLHL_CONTACT_ROLE,
    hlhl_contact_role,
  });
};

export default saveHLHLContactRole;
